<template>
  <div
    class="app-content content"
    :class="[
      { 'show-overlay': $store.state.app.shallShowOverlay },
      $route.meta.contentClass,
    ]"
  >
    <div class="content-overlay loading-icon">
      <div
        class="empty d-flex justify-content-center align-items-center vh-100 flex-column"
      >
        <div
          class="d-flex justify-content-center align-items-center flex-column h-100"
        >
          <b-spinner
            variant="primary"
            label="Text Centered"
          />
          <div
            v-if="loggingOut"
            class="waiting mt-1"
          >
            Logging out...
          </div>
        </div>
      </div>
    </div>
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <loading-page
        v-if="fetchingPermissions || loading"
        class="m-auto m-sm-auto"
      />
      <div
        v-else
        class="content-body"
      >
        <transition
          name="component-fade"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  computed: {
    loggingOut() {
      return this.$store.state.app.loggingOut
    },
    routePath() {
      return this.$route.fullPath
    },
    fetchingPermissions() {
      return this.$store.state.permissions.fetchingPermissions
    },
    loading() {
      return this.$store.state.uploading.loading
    },
  },
  watch: {
    routePath() {
      this.$store.commit('app/SET_ERROR_CODE', null)
    },
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition,
      contentWidth,
    }
  },
}
</script>
